import { render, staticRenderFns } from "./registrationDetail.vue?vue&type=template&id=4e0085c1&scoped=true&"
import script from "./registrationDetail.vue?vue&type=script&lang=js&"
export * from "./registrationDetail.vue?vue&type=script&lang=js&"
import style0 from "./registrationDetail.vue?vue&type=style&index=0&id=4e0085c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0085c1",
  null
  
)

export default component.exports